import axios from "axios";
import { getEnvironment } from "../utils/getEnvironment";
import { PeriodSelection } from "../components/Dashboard/Analytics/types";

const environment = getEnvironment();

export interface ServiceStat {
    name: string;
    revenue: number;
    count: number;
}

export interface ServicesAnalyticsData {
    services: ServiceStat[];
    dormantServices: { name: string }[];
}

export default class ServicesAnalytics {
    /** Range derived server-side from period + reference date (or from/to). */
    public static readonly info = async (
        uuid: string,
        brand: string,
        location: string,
        selection: PeriodSelection
    ) => {
        const params: Record<string, string> = {
            period: selection.period,
            date: selection.date,
        };
        if (selection.period === "custom") {
            if (selection.from) params.from = selection.from;
            if (selection.to) params.to = selection.to;
        }
        return (await axios
            .get(
                `${environment.api_url}/${brand}/location/${location}/analytics/services-analytics`,
                { headers: { "User-Token": uuid }, params }
            )
            .then((res) => (res.status === 200 ? res.data : undefined))
            .catch(console.error)) as ServicesAnalyticsData | undefined;
    };
}
